"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.telemetryHelper = void 0;
const constants_1 = require("./constants");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
class telemetryHelper {
    static sendSuccessEvent(ctx, eventName, properties = {}, measurements = {}) {
        var _a;
        properties[constants_1.TelemetryKey.Component] = constants_1.Constants.PLUGIN_DEV_NAME;
        properties[constants_1.TelemetryKey.Success] = constants_1.TelemetryValue.Success;
        (_a = ctx.telemetryReporter) === null || _a === void 0 ? void 0 : _a.sendTelemetryEvent(eventName, properties, measurements);
    }
    static sendErrorEvent(ctx, eventName, e, properties = {}, measurements = {}) {
        var _a;
        properties[constants_1.TelemetryKey.Component] = constants_1.Constants.PLUGIN_DEV_NAME;
        properties[constants_1.TelemetryKey.Success] = constants_1.TelemetryValue.Fail;
        if (e instanceof teamsfx_api_1.SystemError) {
            properties[constants_1.TelemetryKey.ErrorType] = constants_1.TelemetryValue.SystemError;
        }
        else if (e instanceof teamsfx_api_1.UserError) {
            properties[constants_1.TelemetryKey.ErrorType] = constants_1.TelemetryValue.UserError;
        }
        properties[constants_1.TelemetryKey.ErrorMessage] = e.message;
        properties[constants_1.TelemetryKey.ErrorCode] = e.name;
        (_a = ctx.telemetryReporter) === null || _a === void 0 ? void 0 : _a.sendTelemetryErrorEvent(eventName, properties, measurements);
    }
}
exports.telemetryHelper = telemetryHelper;
//# sourceMappingURL=telemetry-helper.js.map